import { Box, Button, Container, Grid, IconButton, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';



const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

let dep = '';
let esc = '';
let ser = '';
let ent = '';
let sal = '';
let lug = '';
let vin = '';
class ConsultasDatosPersonales extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            volver: false,
            infousuario: {},
            departamentos: [],
            escalafones: [],
            serieBase: [],
            horasEntrada: [],
            lugaresTrabajo: [],
            vinculacion: [],
            busqueda: {
                numeroFuncionario: sessionStorage.numeroFuncionario,
            }
        }
        this.manejarAtras = this.manejarAtras.bind(this);
    }


    async componentDidMount(){
        const cargaUtil = JSON.stringify(this.state.busqueda);

        const infoSol = await fetch(`${Constantes.RUTA_API}/obtener_funcionario.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datosInfoSol = await infoSol.json();
        if(datosInfoSol){
            this.setState({
                infousuario: datosInfoSol[0],
            });
        }

        const departamento = await fetch(`${Constantes.RUTA_API}/obtener_departamentos.php`);
        const datoDepartamento = await departamento.json();
        this.setState({
            departamentos: datoDepartamento,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });

        const serie = await fetch(`${Constantes.RUTA_API}/obtener_series.php`);
        const datoSerie = await serie.json();
        this.setState({
            serieBase: datoSerie,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntrada: datosEntrada,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTrabajo: datoLugar,
        });

        const vin = await fetch(`${Constantes.RUTA_API}/obtener_vinculaciones.php`);
        const dat = await vin.json();
        this.setState({
            vinculacion: dat,
        });
    }

    render(){
        return (
            <>
                {sessionStorage.login
                ?
                    <Container>
                        {this.state.volver
                        ?
                            <Redirect to='/Consultas'/>
                        :
                            null
                        }
                        <h3>Datos Funcionario</h3>
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        <br/>
                        <fieldset>
                            <legend>DATOS PERSONALES</legend>
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.5}>
                                        <Item>PRIMER NOMBRE</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.primerNombre}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>

                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>SEGUNDO NOMBRE</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.segundoNombre}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>PRIMER APELLIDO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.primerApellido}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>SEGUNDO APELLIDO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.segundoApellido}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>C.I.</Item>
                                    </Grid>
                                    {String(this.state.infousuario.ci).length === 8
                                    ?
                                        <Grid item xs={2}>
                                            <Item>{String(this.state.infousuario.ci).substring(0,1)}.{String(this.state.infousuario.ci).substring(1,4)}.{String(this.state.infousuario.ci).substring(4,7)}-{String(this.state.infousuario.ci).substring(7,8)}</Item>
                                        </Grid>
                                    :
                                        <Grid item xs={2}>
                                            <Item>{String(this.state.infousuario.ci).substring(0,1)}.{String(this.state.infousuario.ci).substring(1,4)}.{String(this.state.infousuario.ci).substring(4,7)}</Item>
                                        </Grid>
                                    }
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>FECHA NACIMIENTO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{String(this.state.infousuario.fechaNacimiento).substring(8,10) + '/' + String(this.state.infousuario.fechaNacimiento).substring(5,7) + '/' + String(this.state.infousuario.fechaNacimiento).substring(0,4)}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>CREDENCIAL</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.credencialSerie + ' ' + this.state.infousuario.credencialNumero}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>DIRECCION</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.direccionCalle + ' ' + this.state.infousuario.direccionNumero}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>LOCALIDAD</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.direccionLocalidad}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>DEPARTAMENTO</Item>
                                    </Grid>
                                    {this.state.departamentos.map((name2) => {
                                        if(name2.idDepartamentos === this.state.infousuario.direccionDepartamento){
                                            dep = name2.descripcion;
                                        }
                                    })}
                                    <Grid item xs={2}>
                                        <Item>{dep}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>TELEFONO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.telefono}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>CELULAR</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.celular}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>CARNE DE SALUD</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{String(this.state.infousuario.carneSalud).substring(8,10) + '/' + String(this.state.infousuario.carneSalud).substring(5,7) + '/' + String(this.state.infousuario.carneSalud).substring(0,4)}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>SEXO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.infousuario.sexo === 0 ? <Item>MASCULINO</Item> : <Item>FEMENINO</Item> }
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                </Grid>
                            </Box>
                        </fieldset>
                        <br/>
                        <fieldset>
                            <legend>DATOS FUNCIONARIO</legend>
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.5}>
                                        <Item>NUMERO FUNCIONARIO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.numeroFuncionario}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>FECHA DE INGRESO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                    <Item>{String(this.state.infousuario.ingresoInstitucion).substring(8,10) + '/' + String(this.state.infousuario.ingresoInstitucion).substring(5,7) + '/' + String(this.state.infousuario.ingresoInstitucion).substring(0,4)}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>CARGO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.cargo}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>ESCALAFON</Item>
                                    </Grid>
                                    {this.state.escalafones.map((name2) => {
                                        if(name2.idEscalafon === this.state.infousuario.escalafon){
                                            esc = name2.descripcion;
                                        }
                                    })}
                                    <Grid item xs={2}>
                                        <Item>{esc}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>GRADO</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>{this.state.infousuario.grado}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>SERIE CONCURSO</Item>
                                    </Grid>
                                    {this.state.serieBase.map((name2) => {
                                        if(name2.idSerie === this.state.infousuario.serieConcurso){
                                            ser = name2.descripcion;
                                        }
                                    })}
                                    <Grid item xs={2}>
                                        <Item>{ser}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    {/*<Grid item xs={2.5}>
                                        <Item>HORARIO ENTRADA</Item>
                                    </Grid>
                                    {this.state.horasEntrada.map((name2) => {
                                        if(name2.idEntrada === this.state.infousuario.horaEntrada){
                                            ent = name2.descripcion;
                                        }
                                    })}
                                    <Grid item xs={2}>
                                        <Item>{ent}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>HORARIO SALIDA</Item>
                                    </Grid>
                                    {this.state.horasEntrada.map((name2) => {
                                        if(name2.idEntrada === this.state.infousuario.horarioSalida){
                                            sal = name2.descripcion;
                                        }
                                    })}
                                    <Grid item xs={2}>
                                        <Item>{sal}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>*/}
                                    <Grid item xs={2.5}>
                                        <Item>LUGAR DE TRABAJO</Item>
                                    </Grid>
                                    {this.state.lugaresTrabajo.map((name2) => {
                                        if(name2.idLugaresTrabajo === this.state.infousuario.lugar){
                                            lug = name2.lugar;
                                        }
                                    })}
                                    <Grid item xs={2}>
                                        <Item>{lug}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>VINCULACION</Item>
                                    </Grid>
                                    {this.state.vinculacion.map((name2) => {
                                        if(name2.idVinculacion === this.state.infousuario.vinculacion){
                                            vin = name2.descripcion;
                                        }
                                    })}
                                    <Grid item xs={2}>
                                        <Item>{vin}</Item>
                                    </Grid>
                                    <Grid item xs={0.5}>
                                        
                                    </Grid>
                                </Grid>
                            </Box>
                            <br/>
                        </fieldset>
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                    </Container>
                :
                <Redirect to='/login'/>
                }
            </>
        )//Final return
    }//Final render

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            volver: true,
        })
    }
}

export default ConsultasDatosPersonales